import React from "react";
import styled from "styled-components";
import { useLanguage } from "../../contexts/LanguageContext";
import { ProjectContainer, ProjectTitle, ProjectInfo } from "./styles";

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;

  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }

  p {
    line-height: 24px;
    margin-bottom: 15px;
  }

  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;

    &.img-centered {
      display: block;
      margin: 0 auto 20px auto;
    }

    &.team-image {
      max-width: 500px;
    }
  }

  a {
    color: #f34452;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &.btn {
      background: #f34452;
      color: #fff;
      padding: 12px 30px;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 3px;
      transition: all 0.3s;
      display: inline-block;

      &:hover {
        background: #d63946;
        text-decoration: none;
      }
    }
  }

  iframe {
    width: 100%;
    max-width: 500px;
    height: 281px;
    border: 1px solid #eee;
    margin: 20px 0;
  }

  ul {
    &.textleft {
      text-align: left;

      li {
        margin-bottom: 15px;
        line-height: 24px;
      }
    }

    &.list-inline {
      list-style: none;
      padding: 0;
      display: flex;
      gap: 20px;
      flex-wrap: wrap;

      li {
        b {
          color: #333;
        }
      }
    }
  }

  .closeBtn {
    text-align: center;
    margin-top: 30px;

    button {
      background: #007bff;
      color: #fff;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;

      &:hover {
        background: #0056b3;
      }

      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectGiveNextProps {}

const ProjectGiveNext: React.FC<ProjectGiveNextProps> = () => {
  const { t } = useLanguage();

  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t("givenext.title")}</h2>
        <p className="tags">{t("givenext.role")}</p>
      </ProjectTitle>

      <ProjectDescription>{t("givenext.description")}</ProjectDescription>

      <ProjectInfo>
        <p>
          <b>{t("givenext.roleLabel")}</b> {t("givenext.myRole")}
        </p>
        <p>
          <b>{t("givenext.skillsLabel")}</b> {t("givenext.skillsUtilized")}
        </p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t("givenext.aboutClient")}</h4>
        <p>{t("givenext.aboutClientDesc")}</p>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t("givenext.ourActivities")}</h4>
        <ul className="textleft">
          <li>{t("givenext.activity1")}</li>
          <li>{t("givenext.activity2")}</li>
          <li>{t("givenext.activity3")}</li>
          <li>{t("givenext.activity4")}</li>
        </ul>
        <img loading="lazy" decoding="async"
          className="img-responsive img-centered"
          src="/images/projects/givenext03-min.webp"
          alt="givenext"
        />
        <img loading="lazy" decoding="async"
          className="img-responsive img-centered"
          src="/images/projects/givenext02-min.webp"
          alt="givenext"
        />
        <img loading="lazy" decoding="async"
          className="img-responsive img-centered"
          src="/images/projects/givenext04-min.webp"
          alt="givenext"
        />
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t("givenext.prototypesDemo")}</h4>
        <iframe
          src="https://player.vimeo.com/video/162769295"
          frameBorder="0"
          allowFullScreen
          title="GiveNext Prototypes Demo"
        ></iframe>
      </ProjectWrapper>

      <ProjectWrapper>
        <h4>{t("givenext.ourTeam")}</h4>
        <img loading="lazy" decoding="async"
          className="img-responsive img-centered team-image"
          src="/images/projects/givenext01-min.webp"
          alt="team"
        />
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li>
            <b>{t("givenext.dateLabel")}</b> {t("givenext.dateRange")}
          </li>
          <li>
            <b>{t("givenext.clientLabel")}</b> {t("givenext.client")}
          </li>
          <li>
            <b>{t("givenext.teamMembersLabel")}</b> {t("givenext.teamMembers")}
          </li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectGiveNext;
